import a from "react";
import t from "prop-types";
import f from "classnames";
import { I as d } from "./Icon-ByeAHRM4.es.js";
import { M as c } from "./Modal-QEuhDWbw.es.js";
import D from "./DatePicker/DatePickerPanel/index.es.js";
import { T as g } from "./index-BB-Wk85r.es.js";
import { a as u } from "./index-DYWWIBK7.es.js";
import { a as n } from "./propTypes-DVvgo52A.es.js";
import { f as y } from "./utils-B8CGXZ5v.es.js";
import { s as r } from "./DatePicker.module-CA_9Z_0M.es.js";
const o = (e) => {
  const m = /* @__PURE__ */ a.createElement(g.Body2, { responsive: !0 }, /* @__PURE__ */ a.createElement("span", { className: r.date }, y(e.start, e.end, e.showDays)));
  return /* @__PURE__ */ a.createElement(
    c,
    {
      ariaLabel: e.ariaLabel,
      ariaLabelledBy: e.ariaLabelledBy,
      align: e.align,
      floating: e.floating,
      launcher: (l) => /* @__PURE__ */ a.createElement(
        "div",
        {
          className: f(
            r.launcher,
            l && r.open,
            e.floating && r.floating
          )
        },
        /* @__PURE__ */ a.createElement(d, { name: "calendar", color: "currentColor", size: 18 }),
        m,
        /* @__PURE__ */ a.createElement(
          u,
          {
            searchIcon: !1,
            dark: !1,
            expanded: l,
            disabled: !1
          }
        )
      ),
      panel: (l) => /* @__PURE__ */ a.createElement(
        D,
        {
          start: e.start,
          end: e.end,
          onSetRange: (i, s) => {
            e.onSetRange(i, s), l(!1);
          },
          onClose: () => l(!1),
          showDays: e.showDays,
          minDate: e.minDate,
          maxDate: e.maxDate,
          appendElement: e.appendElement
        }
      )
    }
  );
};
o.propTypes = {
  /** Accessible modal name provided to the user */
  ariaLabel: t.string,
  /** HTML id of alternate label component */
  ariaLabelledBy: t.string,
  /** The start of the currently-selected date range (see shape below). */
  start: n,
  /** The end of the currently-selected date range. */
  end: n,
  /** Align the date picker launch button on either the left or the right of the container. */
  align: t.oneOf(["left", "right"]),
  /** Allows individual days to be selected, as opposed to individual months. */
  showDays: t.bool,
  /** The callback prop triggered when the date range is successfully changed.
   * The first and second arguments are the start and end dates of the range, respectively.
   */
  onSetRange: t.func.isRequired,
  /** When true, DatePicker has squared corners and a box shadow around the launcher.
   * Otherwise, it matches the styles of other filter form components like Select and TextInput.
   */
  floating: t.bool,
  /** Minimum date that can be selected. Dates before this will be greyed out. */
  minDate: n,
  /** Maximum date that can be selected. Dates after this will be greyed out. */
  maxDate: n,
  /**  Any additional element needed to give more information about the date picker
   * (e.g. some text or a tooltip), that will appear below the date range list.
   */
  appendElement: t.node
};
o.defaultProps = {
  ariaLabel: null,
  ariaLabelledBy: null,
  start: null,
  end: null,
  align: "left",
  showDays: !1,
  floating: !1,
  minDate: null,
  maxDate: null,
  appendElement: null
};
export {
  o as D
};
